export enum MachineStatusType {
  DRAFT,
  ACTIVE,
  INACTIVE,
  SOLD
}

export enum MachineStatusLabelType {
  DRAFT = 'Draft',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  SOLD = 'Sold'
}
